import { useEffect, useState } from 'react';

import AssignmentIcon from '@mui/icons-material/Assignment';

import FactCheckIcon from '@mui/icons-material/FactCheck';

import BugReportIcon from '@mui/icons-material/BugReport';

import TimelineIcon from '@mui/icons-material/Timeline';

import { DashboardLayout } from '@/shared/layouts/DashboardLayout';

import { KpiGrid } from '@/components/ui/KpiGrid';

import { StatCard } from '@/components/ui/StatCard';

import { DashboardSkeleton } from '@/components/ui/Skeleton';

import { QuickActionGrid } from '@/components/ui/QuickActionGrid';

import { PageSection } from '@/components/ui/PageSection';

import { projectsApi } from '@/api/projects.api';

import type { ProjectsDashboardSummary } from '@/types/projects';

import { showApiError } from '@/utils/apiError';



const QUICK_ACTIONS = [

  { to: '/projects/list', label: 'Projects', description: 'All active and archived projects' },

  { to: '/projects/tasks', label: 'Tasks', description: 'Work items across projects' },

  { to: '/projects/boards', label: 'Boards', description: 'Kanban and sprint boards' },

  { to: '/projects/sprints', label: 'Sprints', description: 'Agile iteration planning' },

  { to: '/projects/timesheets', label: 'Timesheets', description: 'Time logging and approval' },

  { to: '/projects/gantt', label: 'Gantt', description: 'Timeline and dependencies' },

  { to: '/projects/reports', label: 'Reports', description: 'Burndown, velocity, and exports' },

  { to: '/projects-portal/login', label: 'Client portal', description: 'External stakeholder access' },

];



export function ProjectsDashboardPage() {

  const [stats, setStats] = useState<ProjectsDashboardSummary | null>(null);

  const [loading, setLoading] = useState(true);



  useEffect(() => {
    projectsApi

      .dashboardSummary()

      .then(setStats)

      .catch((err) => showApiError(err, 'Failed to load projects dashboard'))

      .finally(() => setLoading(false));

  }, []);



  if (loading) {

    return (

      <DashboardLayout

        moduleLabel="Projects"

        title="Projects Dashboard"

        description="Execution layer for projects, tasks, issues, and sprint delivery"

      >

        <DashboardSkeleton kpiCount={4} />

      </DashboardLayout>

    );

  }



  return (

    <DashboardLayout

      moduleLabel="Projects"

      title="Projects Dashboard"

      description="Execution layer for projects, tasks, issues, and sprint delivery"

    >

      <KpiGrid columns={4}>

        <StatCard title="Projects" value={stats?.projects ?? '—'} icon={<AssignmentIcon />} />

        <StatCard title="Tasks" value={stats?.tasks ?? '—'} icon={<FactCheckIcon />} />

        <StatCard title="Issues" value={stats?.issues ?? '—'} icon={<BugReportIcon />} />

        <StatCard title="Active Sprints" value={stats?.activeSprints ?? '—'} icon={<TimelineIcon />} />

      </KpiGrid>



      <PageSection title="Quick actions">

        <QuickActionGrid items={QUICK_ACTIONS} columns={4} />

      </PageSection>

    </DashboardLayout>

  );

}


